<template>
  <div class="company-pricing" :class="{ inverted }">
    <div class="pricing-overview">
      <PagesPricingOverview
        :highlightPlan="['premium']"
        :showOnlyHighlighted="true"
        :scaleHighlitedPlan="false"
        :showCTAButton="false"
        :showAllPricingPlansButton="false"
      />
    </div>

    <div class="pricing-explanation">
      <h2>
        {{
          $t(
            "app.components.pricing.companies.why_we_recommend_the_companies_plan",
          )
        }}
      </h2>

      <p>
        {{
          $t("app.components.pricing.companies.companies_plan_description_1")
        }}
      </p>

      <p>
        {{
          $t("app.components.pricing.companies.companies_plan_description_2")
        }}
      </p>

      <p>
        <strong>
          {{ $t("app.components.pricing.companies.get_started_with_premium") }}
        </strong>
      </p>

      <div class="cta-buttons">
        <NuxtLink to="/contact" class="cta-button">
          {{ $t("website.contact_us") }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  inverted: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.company-pricing {
  padding: 4rem 2rem;
  padding: 5% 10%;

  display: grid;
  grid-template-columns: 1.5fr 1.5fr;
  gap: 5%;

  align-items: center;
  text-align: left;
}

.pricing-overview {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.pricing-explanation {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.pricing-explanation h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
}

.pricing-explanation p {
  font-size: 1.1rem;
  color: #4b5563;
  line-height: 1.8;
}

.pricing-explanation ul {
  padding-left: 1rem;
}

.pricing-explanation ul li {
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
}

.pricing-section .cta-buttons {
  display: flex;
  gap: 1rem;
}

/* General */
.cta-button {
  display: inline-block;
  font-size: 1rem;
  padding: 0.8rem 1.5rem;
  background: linear-gradient(135deg, #ff6b35 0%, #ffa94d 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
  width: max-content;
  font-weight: 600;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 107, 53, 0.4);
}

.cta-button:focus {
  outline: 2px solid #ffa94d;
  outline-offset: 2px;
}

.cta-button:active {
  transform: translateY(0);
}

.cta-button-outline {
  background: transparent;
  color: #ff6b35;
  border: 2px solid #ff6b35;
}

.cta-button-outline:hover {
  background: #ff6b35;
  color: #ffffff;
}

/* Inverted Styles */
.company-pricing.inverted {
  grid-template-columns: 1.5fr 1.5fr;
}

.company-pricing.inverted .pricing-explanation {
  order: -1;
}

.company-pricing.inverted .pricing-overview {
  order: 1;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .company-pricing {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .company-pricing.inverted {
    grid-template-columns: 1fr;
  }

  .company-pricing.inverted .pricing-overview {
    order: 0;
  }

  .company-pricing.inverted .pricing-explanation {
    order: 1;
  }

  .pricing-explanation {
    margin-top: 2rem;
  }

  .pricing-section .cta-buttons {
    flex-direction: column;
    gap: 1rem;
  }

  .cta-buttons {
    flex-direction: column;
  }
}
</style>
